module.exports = __webpack_public_path__ + "img/modal-out-icon.4e888dcf.svg";